import React from 'react'
import { css, cx } from '@linaria/core'
import { i18n } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import { boolAttr } from '@fs/zion-frontend-friends'
import { useContainerWidth, Separator } from '@fs/zion-ui'
import { useRootsTechBannerViewContext, viewTypes } from './internal/RootsTechBannerViewProvider'
import { useRootsTechBannerContext } from './internal/RootsTechBannerProvider'

const pillBaseCss = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #000;
  color: #fff;
  border-radius: 50px;
  margin: 0;
  min-height: 38px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.5));
  &:hover {
    filter: brightness(0.8) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.5));
  }
  &:active {
    filter: brightness(0.9);
  }
  &:not([wrap]) {
    white-space: nowrap;
  }
`
const whiteButtonCss = css`
  background: #fff !important;
  color: #000 !important;
  &:hover {
    background: #fff !important;
    color: #000 !important;
    filter: none !important;
    transform: scale(1.04);
`
const pillSmFontCss = css`
  font-size: 12.5px;
  padding: 5px 20px;
`
const pillCss = css`
  font-size: 16px;
  padding: 9px 34px;
`

const pillSm = cx(pillBaseCss, pillSmFontCss)
const pillReg = cx(pillBaseCss, pillCss)

export default function RootsTechBannerButton({ to, wrap, children, white = false, className, ...props }) {
  const viewType = useRootsTechBannerViewContext()
  const { analyticsName } = useRootsTechBannerContext()
  const atSize = useContainerWidth()
  const isSmRu = i18n.language === 'ru' && atSize({ default: true, sm: false })

  let btnRegSize = atSize({
    default: pillSm,
    xs: pillReg,
  })

  if (isSmRu) {
    btnRegSize = pillSm
  }

  return (
    <>
      {viewType === viewTypes.EXPANDED && <Separator size={atSize({ default: 'sm', xxl: 'md' })} />}
      <Link
        to={to}
        linkName={`RT_Banner: ${analyticsName}: Button Click`}
        className={cx(btnRegSize, white ? whiteButtonCss : undefined, className)}
        wrap={boolAttr(wrap)}
        external
        noLinkStyles
        target="_blank"
        {...props}
      >
        {children}
      </Link>
    </>
  )
}
